import { useState, useEffect } from 'react';
import { devError } from '../../utils/devLog';
import {
  NOMINATION_STATUS,
  ELECTION_TYPE,
  CM_PRIMARY_ID,
} from '../../utils/constants';

export const usePendingCOI = (
  userDetails,
  isSCMember,
  isSCChair,
  coiDeclarationArray,
  nominationArray,
  getCommitteeInfo,
) => {
  const [hasPendingCOI, setHasPendingCOI] = useState(false);

  useEffect(() => {
    if (
      !userDetails?.id ||
      (!isSCMember && !isSCChair) ||
      !coiDeclarationArray ||
      !nominationArray
    ) {
      setHasPendingCOI(false);
      return;
    }

    try {
      const committeeInfo = getCommitteeInfo();

      const relevantNominations = nominationArray.filter((nomination) => {
        if (
          nomination.attributes.nominationStatusTypeId ===
            NOMINATION_STATUS.SUBMITTED ||
          nomination.attributes.nominationStatusTypeId ===
            NOMINATION_STATUS.SHORTLISTED ||
          nomination.attributes.nominationStatusTypeId ===
            NOMINATION_STATUS.RECOMMENDED
        ) {
          if (committeeInfo.id === CM_PRIMARY_ID) {
            return (
              nomination.attributes.electionTypeId ===
                ELECTION_TYPE.CORRESPONDING_MEMBER ||
              nomination.attributes.electionTypeId ===
                ELECTION_TYPE.SPECIAL_ELECTION
            );
          }

          return (
            nomination.attributes.sectionalCommitteeId === committeeInfo.id
          );
        }
        return false;
      });

      const candidateIdsNeedingCOI = [
        ...new Set(
          relevantNominations.map((nom) => nom.attributes.candidateId),
        ),
      ];

      if (candidateIdsNeedingCOI.length === 0) {
        setHasPendingCOI(false);
        return;
      }

      const userCompletedCOIs = coiDeclarationArray.filter((declaration) => {
        const declarationUserId =
          declaration.attributes?.userId || declaration.userId;

        const isCompleted =
          declaration.attributes?.isCompleted ??
          declaration.isCompleted ??
          false;
        const candidateId =
          declaration.attributes?.candidateId || declaration.candidateId;

        return (
          declarationUserId === userDetails.id &&
          isCompleted === true &&
          candidateIdsNeedingCOI.includes(candidateId)
        );
      });

      const completedCandidateIds = userCompletedCOIs.map(
        (declaration) =>
          declaration.attributes?.candidateId || declaration.candidateId,
      );

      const pendingCandidateIds = candidateIdsNeedingCOI.filter(
        (candidateId) => !completedCandidateIds.includes(candidateId),
      );

      setHasPendingCOI(pendingCandidateIds.length > 0);
    } catch (error) {
      devError('Error checking COI declarations:', error);
      setHasPendingCOI(false);
    }
  }, [
    userDetails,
    isSCMember,
    isSCChair,
    coiDeclarationArray,
    nominationArray,
  ]);

  return hasPendingCOI;
};
